import set from 'lodash/set';

function initialState() {
  return {
    id: null,
    name: '',
    email: '',
    rfc: '',
    companyName: '',
    oldRfc: '',
    count: 0,
    page: 1,
    size: 20,
    csv: null,
    csvFileName: '',
    list: [],
    loading: false,
    success: '',
    message: false,
    creditDays: 0,
    creditLimit: 0,
    cellphoneNumber: null,
    zipCode: '',
    taxRegime: '',
    debts: [],
    debtsExpired: [],
    temporal: {
      customerId: 0,
      companyId: 0,
      debts: [],
      debtsExpired: [],
      creditLimit: 0,
      cellphoneNumber: null,
      name: '',
      email: '',
      creditDays: '',
      rfc: '',
      companyName: '',
    },
  };
}

export default {
  setValue(state, { accessor, value }) {
    set(state, accessor, value);
  },
  setValues(state, payload) {
    Object.keys(payload).forEach((key) => {
      set(state, key, payload[key]);
    });
  },
  setInitialState(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      set(state, key, newState[key]);
    });
  },
  setCustomerById(state, payload) {
    Object.keys(payload).forEach((key) => {
      set(state, key, payload[key]);
    });
  },
};
